import { weddingTemplate } from './weddingTemplate';
import { birthdayTemplate } from './birthdayTemplate';
import { corporateTemplate } from './corporateTemplate';
import { holidayTemplate } from './holidayTemplate';
import { basicTemplate } from './basicTemplate';

export const layouts = {
  blank: {
    name: "Blank Canvas",
    elements: []
  },
  basic: {
    name: "Basic Layout",
    elements: basicTemplate.elements || []
  },
  wedding: {
    name: "Wedding Invitation",
    elements: weddingTemplate.elements || []
  },
  birthday: {
    name: "Birthday Party",
    elements: birthdayTemplate.elements || []
  },
  corporate: {
    name: "Corporate Event",
    elements: corporateTemplate.elements || []
  },
  holiday: {
    name: "Holiday Greeting",
    elements: holidayTemplate.elements || []
  }
};

export {
  weddingTemplate,
  birthdayTemplate,
  corporateTemplate,
  holidayTemplate,
  basicTemplate
};